import React from 'react';
import {
    JobType,
    OrderType,
    OfferType,
    MissingRequirementsType
} from '../../types';
import { defaultMissingRequirements } from '../../utils/metadata';
import OfferForm from './OfferForm';
import OfferDetails from './OfferDetails';

type PropsType = {
    order: OrderType | JobType;
    offer: OfferType | null;
    refetch: () => void;
    missingRequirements?: MissingRequirementsType;
};

export default function Offer({
    order,
    offer,
    refetch,
    missingRequirements = defaultMissingRequirements
}: PropsType) {
    return offer?.price
        ? (
            <OfferDetails
                order={order}
                offer={offer}
                refetch={refetch}
            />
        ) : (
            <OfferForm
                order={order}
                refetch={refetch}
                missingRequirements={missingRequirements}
            />
        );
}
